import React from 'react';

const Footer = () => {
  const handlePrivacyClick = (e) => {
    e.preventDefault();
    window.open('https://policies.google.com/privacy', '_blank');
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    window.open('https://policies.google.com/terms', '_blank');
  };

  return (
    <div>
      <p className="k-font-medium k-text-uppercase" style={{lineHeight:'30px'}}>
        © 2024 LeafFilter North, LLC. All rights reserved. Trademarks:
        LeafFilter™, Leaf Filter™ and Gutter Protection Perfection™. This site
        is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" onClick={handlePrivacyClick} className="k-text-no-underline" style={{color:'#337AB7'}}>Privacy Policy</a> and <a href="https://policies.google.com/terms" onClick={handleTermsClick} className="k-text-no-underline" style={{color:'#337AB7'}}>Terms of
        Service apply</a>
      </p>
    </div>
  );
};

export default Footer;
